import { Geraetelog, type GeraetelogPlugin } from '../platform/geraetelog';

/**
 * Das SQL-Log: jede schreibende Anweisung der Ablage am iPad nach `Documents/log-sql.txt`
 * (`ios/App/App/GeraetelogPlugin.swift` rotiert und schreibt).
 *
 * Zweck (Nutzer über Relay, 2026-10-18): scheitert die Übertragung, kann Relay die Ergebnisse
 * aus dem Log nachspielen. Deshalb mit Zeitstempel und **allen** gebundenen Werten im
 * Klartext — auch Passwörter und PINs (Entscheidung des Nutzers, 2026-10-18).
 *
 * Eine Zeile je Anweisung, Format von Relay (`PROTOKOLL-CLIENT-SERVER.md` §7.2):
 * `{"sql","src","t","values"}`. Gemerkt wird erst **nach** dem Erfolg — eine gescheiterte
 * Anweisung nachzuspielen hiesse, einen Stand herzustellen, den es nie gab.
 *
 * ⚠️ **Gebündelt**, nicht je Anweisung ein Brückenaufruf: jeder Aufruf schreibt selbst eine
 * Capacitor-Zeile nach `log.txt`. shortcut: was in den letzten 500 ms vor einem Absturz anfiel,
 * fehlt — kürzer takten, falls das beim Nachspielen auffällt.
 */

const TAKT_MS = 500;

let puffer: string[] = [];
let uhr: ReturnType<typeof setTimeout> | null = null;

export function sqlZeile(sql: string, values: readonly unknown[], t = new Date()): string {
  return JSON.stringify({ sql, src: 'js', t: t.toISOString(), values });
}

export function merkeSql(sql: string, values: readonly unknown[] = [], senke: Pick<GeraetelogPlugin, 'sql'> = Geraetelog): void {
  puffer.push(sqlZeile(sql, values));
  if (uhr !== null) return;
  uhr = setTimeout(() => {
    uhr = null;
    const zeilen = puffer;
    puffer = [];
    // Das Log darf nie selbst zum Fehler werden.
    void senke.sql({ zeilen }).catch(() => undefined);
  }, TAKT_MS);
}
